import utils from '@/util';

const MENU_OPTIONS = [
  {
    nome: 'Principal',
    menuItens: [
      {
        nome: 'Cadastros',
        icon: 'ion-logo-buffer',
        menuItens: [
          {
            path: '/principal/cadastros/centroDeCusto/listar',
            nome: 'Centro de Custo',
            permissao: 134
          },
          {
            path: '/principal/cadastros/localidade/listar',
            nome: 'Localidade',
            permissao: 1
          },
          {
            path: '/principal/cadastros/secao/listar',
            nome: 'Seção',
            permissao: 5
          },
          {
            path: '/principal/cadastros/rota/listar',
            nome: 'Rota',
            permissao: 95
          },
          {
            path: '/principal/cadastros/estabelecimento/listar',
            nome: 'Estabelecimento',
            permissao: 8
          },
          {
            path: '/principal/cadastros/usuario/listar',
            nome: 'Usuário',
            permissao: 11
          },
          {
            path: '/principal/cadastros/gestor/listar',
            nome: 'Gestor',
            permissao: 14,
            requireMfa: true
          },
          {
            path: '/principal/cadastros/arrecadador/listar',
            nome: 'Arrecadador',
            permissao: 175
          },
          { divider: true },
          {
            path: '/principal/cadastros/servico/listar',
            nome: 'Serviços',
            permissao: 17
          },
          {
            path: '/principal/cadastros/circular/listar',
            nome: 'Circular',
            permissao: 57
          },
          {
            nome: 'Controle',
            menuItens: [
              { path: '/principal/cadastros/controle/usuario', nome: 'Usuário', permissao: 88 },
              { path: '/principal/cadastros/controle/serialReport', nome: 'Terminal', permissao: 209 }
            ]
          },
          {
            nome: 'Perfil',
            menuItens: [
              {
                path: '/principal/cadastros/perfil/bonusUsuario/listar',
                nome: 'BetPlus',
                permissao: 612
              },
              {
                path: '/principal/cadastros/perfil/comissao/listar',
                nome: 'Comissão',
                permissao: 210
              },
              {
                path: '/principal/cadastros/perfil/competicao/listar',
                nome: 'Competição',
                permissao: 377
              },
              {
                path: '/principal/cadastros/perfil/cotacao/listar',
                nome: 'Cotação',
                permissao: 195
              },
              {
                path: '/principal/cadastros/perfil/cotacaoFavorito/listar',
                nome: 'Cotação Favorito',
                permissao: 262
              },
              {
                path: '/principal/cadastros/perfil/defesaOddsAutomaticas/listar',
                nome: 'Defesa Odds Automáticas',
                permissao: 834
              },
              {
                path: '/principal/cadastros/perfil/imposto/listar',
                nome: 'Imposto',
                permissao: 311
              },
              {
                path: '/principal/cadastros/perfil/limiteDefesa/listar',
                nome: 'Limite e Defesa',
                permissao: 192
              },
              {
                path: '/principal/cadastros/perfil/limitePadrao/listar',
                nome: 'Limite Padrão',
                permissao: 255
              },
              {
                path: '/principal/cadastros/perfil/riscoPorTipo',
                nome: 'Risco por Tipo',
                permissao: 213
              },
              {
                path: '/principal/cadastros/perfil/subevento/listar',
                nome: 'Subevento',
                permissao: 237
              },
              {
                path: '/principal/cadastros/perfil/usuario/listar',
                nome: 'Usuário',
                permissao: 270,
                requireMfa: true
              },
              {
                path: '/principal/cadastros/perfil/usuarioApostador/listar',
                nome: 'Usuário Apostador',
                permissao: 618
              }
            ]
          },
          {
            path: '/principal/cadastros/produto/listar',
            nome: 'Produtos',
            permissao: 126
          },
          {
            nome: 'Jogos',
            menuItens: [
              {
                path: '/principal/cadastros/games/listar',
                nome: 'Cadastro',
                permissao: 231
              },
              {
                path: '/principal/cadastros/games/categorias/listar',
                nome: 'Categorias',
                permissao: 743
              }
            ]
          },
          {
            path: '/principal/cadastros/tipoDespesa/listar',
            nome: 'Tipo Despesa',
            permissao: 407
          },
          {
            path: '/principal/cadastros/terminal/listar',
            nome: 'Terminal',
            permissao: 696
          },
          {
            path: '/principal/cadastros/pontoVenda/listar',
            nome: 'Ponto de Venda',
            permissao: 932
          },
          {
            nome: 'Gestor Lotérico',
            menuItens: [
              {
                path: '/principal/cadastros/gestorLoterico/apostador/listar',
                nome: 'Apostador',
                permissao: 685
              },
              {
                path: '/principal/cadastros/gestorLoterico/pos/listar',
                nome: 'Ponto de Venda',
                permissao: 629
              },
              {
                path: '/principal/cadastros/gestorLoterico/produto/listar',
                nome: 'Produto',
                permissao: 632
              },
              {
                path: '/principal/cadastros/terminal/listar',
                nome: 'Terminal',
                permissao: 680
              }
            ]
          }
        ]
      },
      {
        nome: 'Afiliados',
        icon: 'ion-ios-contacts',
        menuItens: [
          { path: '/principal/afiliados/campanhas/listar', nome: 'Campanhas', permissao: 598 },
          { path: '/principal/afiliados/afiliados/listar', nome: 'Afiliados', permissao: 596 },
          { path: '/principal/afiliados/acoes/listar', nome: 'Ações', permissao: 599 }
        ]
      },
      {
        nome: 'Bilhetes',
        icon: 'ion-md-pricetags',
        menuItens: [
          { path: '/principal/bilhetes/cancelamento', nome: 'Cancelamento', permissao: 20 },
          { path: '/principal/bilhetes/devolucoes', nome: 'Devoluções', permissao: 52 },
          { path: '/principal/bilhetes/listagem', nome: 'Listagem', permissao: 23 },
          { path: '/principal/bilhetes/premiados', nome: 'Premiados', permissao: 27 }
        ]
      },
      {
        nome: 'Jogos',
        icon: 'ion-md-cash',
        menuItens: [{ path: '/principal/jogos/apostas', nome: 'Apostas', permissao: 926 }]
      },
      {
        nome: 'Sites',
        icon: 'ion-md-code-working',
        menuItens: [
          { path: '/principal/sites/depositos', nome: 'Depósitos (Pins)', permissao: 76 },
          { path: '/principal/sites/saques', nome: 'Resgates (Saques)', permissao: 77 },
          { path: '/principal/sites/logins/listar', nome: 'Logins', permissao: 138 },
          {
            nome: 'Cadastros',
            menuItens: [
              {
                path: '/principal/sites/listar',
                nome: 'Sites',
                permissao: 184
              },
              {
                path: '/principal/cadastros/marcas/listar',
                nome: 'Marcas',
                permissao: 950
              }
            ]
          },
          {
            nome: 'Promoções',
            menuItens: [
              { path: '/principal/sites/promo/listar', nome: 'Cadastros', permissao: 332 },
              { path: '/principal/sites/promo/template/listar', nome: 'Template', permissao: 333 },
              { path: '/principal/sites/promo/remessa/listar', nome: 'Remessa', permissao: 739 },
              { path: '/principal/sites/promo/xtremepush/listar', nome: 'Xtremepush Free Spin', permissao: 864 }
            ]
          },

          {
            nome: 'Conteúdo',
            menuItens: [
              //cms
              { path: '/principal/sites/cms/noticias/listar', nome: 'Blog', permissao: 580 },
              { path: '/principal/sites/cms/banners/listar', nome: 'Banners', permissao: 571 },
              { path: '/principal/sites/cms/paginas/listar', nome: 'Páginas', permissao: 565 },
              { path: '/principal/sites/cms/seo/listar', nome: 'SEO', permissao: 574 },
              { path: '/principal/sites/linksdestaques/listar', nome: 'Links Rápidos', permissao: 241 },
              { path: '/principal/sites/eventosdestaques/listar', nome: 'Eventos Destaque', permissao: 240 }
            ]
          },
          {
            nome: 'Método de Pagamento',
            menuItens: [
              { path: '/principal/sites/metodoPagamento/listar', nome: 'Cadastros', permissao: 322 },
              { path: '/principal/sites/metodoPagamento/template/listar', nome: 'Template', permissao: 325 },
              {
                path: '/principal/sites/metodoPagamento/cartoes/listar',
                nome: 'Cartões Utilizados',
                permissao: 382
              }
            ]
          },
          { path: '/principal/sites/blacklist/listar', nome: 'Blacklist', permissao: 814 },
          {
            path: '/principal/sites/versaoApp/listar',
            nome: 'Versão de Aplicativo',
            permissao: 854
          }
        ]
      },
      {
        nome: 'Resultados',
        icon: 'ion-md-clipboard',
        menuItens: [
          { path: '/principal/resultados/listagem', nome: 'Listagem', permissao: 34 },
          {
            path: '/principal/resultados/pendentes',
            nome: 'Pendentes',
            permissao: 29
          }
        ]
      },
      {
        nome: 'Gerência',
        icon: 'ion-md-people',
        menuItens: [
          { path: '/principal/gerencia/bolao/listar', nome: 'Bolão', permissao: 84 },
          {
            path: '/principal/gerencia/controleIp/listar',
            nome: 'Controle de IP',
            permissao: 202
          },
          {
            path: '/principal/gerencia/risco/listar',
            nome: 'Consultar Risco',
            permissao: 39
          },
          {
            path: '/principal/gerencia/risco/acumulado/listar',
            nome: 'Risco Acumulado',
            permissao: 858
          },
          { path: '/principal/gerencia/cotacao/listar', nome: 'Cotações', permissao: 74 },
          { path: '/principal/gerencia/esporte/listar', nome: 'Esportes', permissao: 44 },
          {
            path: '/principal/gerencia/preferenciaApi/listar',
            nome: 'Preferências API',
            permissao: 132
          },
          {
            nome: 'Defesa',
            menuItens: [
              {
                path: '/principal/gerencia/monitor/listar',
                nome: 'Monitor Sequencial',
                permissao: 646
              },
              {
                path: '/gerencia/riscoPorCombinacao/listar',
                nome: 'Risco por Combinação',
                permissao: 147
              },
              {
                path: '/gerencia/configuracaoDefesa/listar',
                nome: 'Config. Defesa Combinações',
                permissao: 144
              }
            ]
          },
          {
            nome: 'Configurações',
            menuItens: [
              {
                path: '/principal/gerencia/configuracoes/bloqueios',
                nome: 'Bloqueios',
                permissao: 36
              },
              {
                path: '/principal/gerencia/configuracoes/competicoes',
                nome: 'Competições',
                permissao: 114
              },
              {
                path: '/principal/gerencia/configuracao/prioridadeCompeticao/listar',
                nome: 'Prioridade Competição',
                permissao: 819
              },
              {
                path: '/principal/gerencia/configuracoes/evento',
                nome: 'Evento',
                permissao: 40
              },
              {
                path: '/principal/gerencia/prioridadeSubevento/listar',
                nome: 'Prioridade Subevento',
                permissao: 760
              }
            ]
          },
          {
            nome: 'Super Odds',
            menuItens: [
              {
                path: '/principal/gerencia/superOdds/listarConfiguracoes',
                nome: 'Configurações',
                permissao: 883
              },
              {
                path: '/principal/gerencia/riscoAcumuladoSuperOdds/listar',
                nome: 'Monitoramento de Risco',
                permissao: 888
              }
            ]
          }
        ]
      },
      {
        nome: 'Financeiro',
        icon: 'ion-md-cash',
        menuItens: [
          {
            path: '/principal/financeiro/extratoComSaldo',
            nome: 'Extrato com Saldo',
            permissao: 98
          },
          { path: '/acerto/listar', nome: 'Lançamentos', permissao: 99 },
          {
            path: '/estabelecimento/saldo/listar',
            nome: 'Monitor',
            permissao: 102
          },
          {
            path: '/corteFinanceiro',
            nome: 'Corte Financeiro',
            permissao: 158
          },
          {
            nome: 'Agendamentos',
            menuItens: [
              {
                path: '/agendamento/despesa/listar',
                nome: 'Despesa',
                permissao: 181
              }
            ]
          }
        ]
      },
      {
        nome: 'SIGAP',
        icon: 'ion-md-filing',
        menuItens: [
          ,
          { path: '/principal/sites/usuariosImpedidos/listar', nome: 'Usuários Impedidos', permissao: 896 },
          {
            icon: 'ion-md-search',
            nome: 'Consulta Movimentos',
            path: '/principal/sigap/movimentos/listar',
            permissao: 824
          },
          {
            icon: 'ion-md-attach',
            nome: 'Envios',
            path: '/principal/sigap/envios/listar',
            permissao: 806
          },
          {
            icon: 'ion-md-attach',
            nome: 'Valores prescritos recolhidos',
            path: '/principal/sigap/devolucao/listar',
            permissao: 914
          },
          {
            icon: 'ion-md-settings',
            nome: 'Correção e Retificação',
            path: '/principal/sigap/correcaoRetificacao/listar',
            permissao: 921
          },
          {
            icon: 'ion-md-wallet',
            nome: 'Operador Mensal',
            path: '/principal/sigap/operadorMensal/listar',
            permissao: 807
          }
        ]
      }
    ]
  },
  {
    nome: 'Análise',
    menuItens: [
      {
        nome: 'Configurações',
        icon: 'ion-md-cog',
        requiredBi: true,
        menuItens: [
          {
            path: '/principal/cadastros/layout_metabase_dashboard/listar',
            nome: 'Layout Metabase Dashboard',
            requiredBi: true,
            permissao: 713
          },
          {
            path: '/principal/cadastros/metabase_dashboard/listar',
            nome: 'Metabase Dashboard',
            requiredBi: true,
            permissao: 712
          },
          {
            path: '/principal/cadastros/perfil_metabase_dashboard/listar',
            nome: 'Perfil Metabase Dashboard',
            requiredBi: true,
            permissao: 714
          }
        ]
      }
    ]
  },
  {
    nome: 'Relatórios',
    menuItens: [
      {
        nome: 'ATM',
        icon: 'ion-md-browsers',
        menuItens: [
          {
            path: '/relatorios/financeiro/movimentoDetalhado',
            nome: 'Movimento Detalhado',
            permissao: 290
          },
          {
            path: '/relatorios/financeiro/movimentoAgrupado',
            nome: 'Movimento Agrupado',
            permissao: 734
          }
        ]
      },
      {
        nome: 'Auditoria',
        icon: 'ion-ios-journal',
        menuItens: [
          {
            path: '/relatorios/financeiro/transacoesAltoValor',
            nome: 'Transações de Alto Valor',
            permissao: 794
          },
          {
            path: '/relatorios/financeiro/trilhaAuditoria',
            nome: 'Trilha Auditoria',
            permissao: 795
          },
          {
            path: '/relatorios/financeiro/auditoriaProdutosEstaduais',
            nome: 'Auditoria de Vendas',
            permissao: 903
          }
        ]
      },
      {
        nome: 'Bolão',
        icon: 'ion-md-football',
        menuItens: [
          {
            path: '/relatorios/bolao/apuradoBolao',
            nome: 'Apurado por Bolão',
            permissao: 150
          },
          { path: '/relatorios/bolao/vendaBolao', nome: 'Vendas', permissao: 94 }
        ]
      },
      {
        nome: 'Financeiro',
        icon: 'ion-md-cash',
        menuItens: [
          {
            path: '/relatorios/financeiro/Apurado',
            nome: 'Apurado',
            permissao: 47
          },
          {
            path: '/relatorios/financeiro/ApuradoDespesas',
            nome: 'Apurado com Despesas',
            permissao: 288
          },
          {
            path: '/relatorios/financeiro/ApuradoOrigem',
            nome: 'Apurado Premios Origem',
            permissao: 217
          },
          {
            path: '/relatorios/financeiro/ApuradoOrigemDespesas',
            nome: 'Apurado Origem por Despesas',
            permissao: 113
          },
          {
            path: '/relatorios/financeiro/ApuradoMetodoPagamento',
            nome: 'Apurado V3',
            permissao: 617
          },
          {
            path: '/relatorios/financeiro/ApuradoUsuario',
            nome: 'Apurado Usuário',
            permissao: 617
          },
          {
            path: '/relatorios/financeiro/acertoFinanceiro',
            nome: 'Acerto Financeiro',
            permissao: 235
          },
          {
            path: '/relatorios/financeiro/bilhetesPorPartidaReport',
            nome: 'Bilhetes por Partida',
            permissao: 91
          },
          {
            path: '/relatorios/financeiro/centroDeCusto',
            nome: 'Centro de Custo',
            permissao: 387
          },
          { path: '/relatorios/financeiro/cobrancaReport', nome: 'Cobrança', permissao: 179 },
          { path: '/relatorios/financeiro/coletaReport', nome: 'Coleta', permissao: 173 },
          {
            path: '/relatorios/financeiro/comissaoRetidaReport',
            nome: 'Comissão Retida',
            permissao: 49
          },
          {
            path: '/relatorios/financeiro/consumoBobinas',
            nome: 'Relatório Consumo de Bobinas',
            permissao: 893
          },
          {
            path: '/relatorios/financeiro/comissaoPorFaixa',
            nome: 'Comissão por Faixa',
            permissao: 229
          },
          { path: '/despesaReport', nome: 'Despesas', permissao: 190 },
          {
            path: '/relatorios/financeiro/evolucaoVendas',
            nome: 'Evolução de Vendas',
            permissao: 125
          },
          {
            path: '/relatorios/financeiro/evolucaoPontos',
            nome: 'Evolução de Pontos',
            permissao: 156
          },
          {
            path: '/relatorios/financeiro/extrato',
            nome: 'Extrato',
            permissao: 50
          },
          {
            path: '/relatorios/financeiro/guiaDeMovimentoLoja',
            nome: 'Guia De Movimento (Loja)',
            permissao: 724
          },
          {
            path: '/relatorios/financeiro/guiaPorHora',
            nome: 'Guia por Hora',
            permissao: 127
          },
          { path: '/relatorios/financeiro/liquido', nome: 'Líquido por Tipo de Usuário', permissao: 787 },
          {
            path: '/relatorios/financeiro/listagemBilhetes',
            nome: 'Listagem de Bilhetes',
            permissao: 154
          },
          {
            path: '/relatorios/financeiro/monitorOperacionalTransacoes',
            nome: 'Monitor Operacional Transações',
            permissao: 790
          },
          {
            path: '/relatorios/financeiro/tipoAposta',
            nome: 'Tipo de Aposta',
            permissao: 68
          },
          {
            path: '/relatorios/financeiro/premioPagoMetodoPagamento',
            nome: 'Prêmios Pagos',
            permissao: 784
          },
          {
            path: '/relatorios/financeiro/ticketMedio',
            nome: 'Ticket Médio',
            permissao: 266
          },
          {
            path: '/pontosInoperantesReport',
            path: '/relatorios/financeiro/pontosInoperantesReport',
            nome: 'Pontos Inoperantes',
            permissao: 117
          },
          {
            path: '/relatorios/financeiro/pontosOperandoReport',
            nome: 'Pontos Operando',
            permissao: 161
          },
          {
            path: '/relatorios/financeiro/posicaoDiaria',
            nome: 'Posição Diária',
            permissao: 133
          },
          {
            path: '/relatorios/financeiro/seriaisInoperantes',
            nome: 'Seriais Inoperantes',
            permissao: 168
          },
          {
            path: '/relatorios/financeiro/vendasProdutosExternos',
            nome: 'Vendas Produtos Externos',
            permissao: 788
          },
          {
            path: '/relatorios/financeiro/VendasPorEstado',
            nome: 'Vendas por Estado',
            permissao: 165
          }
        ]
      },
      {
        nome: 'Sites',
        icon: 'ion-md-pricetag',
        menuItens: [
          { path: '/relatorios/sites/pin', nome: 'PIN', permissao: 92 },
          {
            path: '/relatorios/sites/cobrancaDeProdutos',
            nome: 'Cobrança de Produtos',
            permissao: 131
          },
          {
            path: '/relatorios/sites/saldoPin',
            nome: 'Saldo PIN',
            permissao: 142
          },
          {
            path: '/relatorios/sites/eventosFuturos',
            nome: 'Eventos Futuros',
            permissao: 267
          },
          {
            path: '/relatorios/sites/posicaoSaldo',
            nome: 'Posição de Saldo',
            permissao: 315
          },
          { path: '/relatorios/sites/saques', nome: 'Saques', permissao: 157 },
          { path: '/relatorios/sites/sms', nome: 'SMS', permissao: 665 },
          {
            nome: 'Transações',
            menuItens: [
              {
                path: '/relatorios/sites/transacoes',
                nome: 'Transações por Tipo',
                permissao: 243
              },
              {
                path: '/relatorios/sites/transacoesPorLocalidade',
                nome: 'Transações Por Localidade',
                permissao: 644
              },
              {
                path: '/relatorios/sites/transacoesLocalidadeAgrupado',
                nome: 'Transações Por Localidade Agrupado',
                permissao: 624
              },
              {
                path: '/relatorios/sites/transacoesMetodo',
                nome: 'Transações por Método de Pagamento',
                permissao: 314
              }
            ]
          },
          {
            nome: 'Financeiro',
            menuItens: [
              {
                path: '/relatorios/sites/financeiro/bonus',
                nome: 'Bônus',
                permissao: 244
              },
              {
                path: '/relatorios/sites/financeiro/darf',
                nome: 'DARF',
                permissao: 393
              },
              {
                path: '/relatorios/sites/financeiro/depositos',
                nome: 'Depósitos',
                permissao: 245
              },
              {
                path: '/relatorios/sites/financeiro/resgates',
                nome: 'Resgates',
                permissao: 246
              },
              {
                path: '/relatorios/sites/financeiro/movimento',
                nome: 'Movimento',
                permissao: 247
              }
            ]
          },
          {
            nome: 'Operacional',
            menuItens: [
              {
                path: '/relatorios/sites/operacional/apostas',
                nome: 'Turnover',
                permissao: 248
              },
              {
                path: '/relatorios/sites/operacional/apostas/moeda',
                nome: 'Turnover com moeda',
                permissao: 812
              },
              {
                path: '/reports/sites/operacional/gamesTurnover',
                nome: 'Games Turnover',
                permissao: 643
              },
              {
                path: '/relatorios/sites/operacional/clientesAtivos',
                nome: 'Active Players',
                permissao: 249
              },
              {
                path: '/relatorios/sites/operacional/lancamentosManuais',
                nome: 'Lançamentos Manuais',
                permissao: 789
              },
              {
                path: '/relatorios/sites/operacional/clientesAtivosComDeposito',
                nome: 'New Funded Players',
                permissao: 250
              },
              {
                path: '/relatorios/sites/operacional/usuariosSemDepositos',
                nome: 'Usuários Sem Depósitos',
                permissao: 785
              },
              {
                path: '/relatorios/sites/operacional/freeSpins',
                nome: 'Free Spins',
                permissao: 901
              },
              {
                path: '/relatorios/sites/operacional/prizeDrops',
                nome: 'Prize Drops',
                permissao: 916
              },
              {
                path: '/relatorios/sites/operacional/performancePromo',
                nome: 'Performance Promoções Carrinho',
                permissao: 395
              },
              {
                path: '/relatorios/sites/operacional/registros',
                nome: 'Sign-ups',
                permissao: 251
              },
              {
                path: '/relatorios/sites/operacional/usuariosEmPausa',
                nome: 'Usuários Em Pausa',
                permissao: 829
              },
              {
                path: '/relatorios/sites/operacional/usuariosAutoLimitados',
                nome: 'Usuários com Auto Limitação',
                permissao: 830
              }
            ]
          }
        ]
      },
      {
        nome: 'Rede',
        icon: 'ion-md-globe',
        menuItens: [
          {
            path: '/relatorios/rede/cancelamentos/CancelamentosReport',
            nome: 'Cancelamento',
            permissao: 398
          },
          {
            path: '/relatorios/rede/versoesUsuario/VersoesUsuarioReport',
            nome: 'Versões do Usuário',
            permissao: 54
          }
        ]
      }
    ]
  },
  {
    nome: 'Monitor',
    menuItens: [
      {
        nome: 'Sistema',
        icon: 'ion-md-desktop',
        menuItens: [
          {
            path: '/monitor/sistema/alertas/listar',
            nome: 'Alertas',
            permissao: 63
          },
          { path: '/dashboard', nome: 'Dashboard', permissao: null },
          {
            path: '/monitor/sistema/logs/listar',
            nome: 'Logs',
            permissao: 411
          },
          {
            path: '/monitor/sistema/mensagens/listar',
            nome: 'Mensagens',
            permissao: 557
          }
        ]
      },
      {
        nome: 'Financeiro',
        icon: 'ion-md-cash',
        menuItens: [
          {
            path: '/monitor/financeiro/apurado',
            nome: 'Apurado',
            permissao: 368
          },
          {
            path: '/monitor/financeiro/geral',
            nome: 'Geral',
            permissao: 367
          }
        ]
      },
      {
        nome: 'Trading',
        icon: 'ion-md-git-compare',
        menuItens: [
          { path: '/monitor/trading/evento/listar', nome: 'Evento', permissao: 345 },
          {
            path: '/monitor/trading/fornecedor/listar',
            nome: 'Fornecedor',
            permissao: 359
          },
          { path: '/monitor/trading/grupo/listar', nome: 'Grupo', permissao: 355 },
          { path: '/monitor/trading/grupoOrigem/listar', nome: 'Grupo Origem', permissao: 339 },
          { path: '/monitor/trading/risco/listar', nome: 'Risco', permissao: 376 },
          {
            path: '/monitor/trading/multiplosFornecedores/listar',
            nome: 'Múltiplos Fornecedores',
            permissao: 647
          },
          {
            path: '/principal/monitor/trading/tipoSubevento/listar',
            nome: 'Mercados',
            permissao: 764
          },
          { path: '/monitor/trading/templateOdd/listar', nome: 'Template Odd', permissao: 653 },
          {
            path: '/monitor/trading/eventosMercadoAberto/listar',
            nome: 'Eventos com Mercado Aberto',
            permissao: 832
          },
          {
            path: '/monitor/trading/mercadoAberto/listar',
            nome: 'Mercado Aberto',
            permissao: 833
          }
        ]
      },
      {
        nome: 'Resultados',
        icon: 'ion-md-clipboard',
        menuItens: [
          {
            path: '/resultados/automatico/agendamentos',
            nome: 'Agendamento',
            permissao: 363
          },
          {
            path: '/resultados/automatico/pendentes',
            nome: 'Pendentes',
            permissao: 340
          }
        ]
      },
      {
        nome: 'Cadastros',
        icon: 'ion-logo-buffer',
        menuItens: [
          {
            path: '/monitor/grupoLocalidade/listar',
            nome: 'Grupo Localidade',
            permissao: 552
          }
        ]
      }
    ]
  },
  {
    nome: 'Fornecedor',
    menuItens: [
      {
        nome: 'Trading',
        icon: 'ion-md-git-compare',
        menuItens: [
          { path: '/internalProvider/evento/listar', nome: 'Eventos', permissao: 700 },
          {
            path: '/internalProvider/modalidade/listar',
            nome: 'Modalidade',
            permissao: 693
          }
        ]
      }
    ]
  },
  {
    nome: 'MINCETUR',
    menuItens: [
      {
        nome: 'Reportes Generales',
        icon: 'ion-logo-buffer',
        menuItens: [
          {
            path: '/mincetur/reportesGenerales/checksCritical',
            nome: 'Checks Critical',
            permissao: 772
          },
          {
            path: '/mincetur/reportesGenerales/datosEconomicos',
            nome: 'Datos Económicos',
            permissao: 782
          },
          {
            path: '/mincetur/reportesGenerales/datosTecnicos',
            nome: 'Datos Técnicos',
            permissao: 786
          },
          {
            path: '/mincetur/reportesGenerales/reporteIngresosConsolidados',
            nome: '(3.7.3/8.7.3) Ingresos consolidados',
            permissao: 771
          },
          {
            path: '/mincetur/reportesGenerales/eventosSignificativos',
            nome: '(3.7.5/8.7.5) Eventos Significativos',
            permissao: 773
          },
          {
            path: '/mincetur/reportesGenerales/depositosdelJugador',
            nome: '(3.7.6/8.7.7) Depósitos del Jugador',
            permissao: 769
          },
          {
            path: '/mincetur/reportesGenerales/saquesPorjogador',
            nome: '(3.7.6/8.7.7) Retiros del Jugador',
            permissao: 770
          },
          {
            path: '/mincetur/reportesGenerales/cuentaDelJugador',
            nome: '(3.7.7/8.7.8) Cuenta del Jugador',
            permissao: 767
          },
          {
            path: '/mincetur/reportesGenerales/plataformaDeApuestas',
            nome: '(3.7.8/8.7.9) Plataforma de Apuestas',
            permissao: 768
          }
        ]
      },
      {
        nome: 'Sportsbook',
        icon: 'ion-md-pricetag',
        menuItens: [
          {
            path: '/mincetur/sportsbook/ingresosPorEvento',
            nome: '(8.7.2) Ingresos por Evento',
            permissao: 776
          },
          {
            path: '/mincetur/sportsbook/eventosFuturos',
            nome: '(8.7.4) Eventos Futuros',
            permissao: 777
          },
          {
            path: '/mincetur/sportsbook/apuestasDelJugador',
            nome: '(8.7.7) Apuestas del Jugador',
            permissao: 774
          },
          {
            path: '/mincetur/sportsbook/detalleApuestas',
            nome: '(8.7.7) Detalle Apuestas',
            permissao: 775
          }
        ]
      },
      {
        nome: 'Cassino',
        icon: 'ion-md-cash',
        menuItens: [
          {
            path: '/mincetur/casino/rendimientoDeJuego',
            nome: '(3.7.2) Rendimiento de Juego',
            permissao: 780
          },
          {
            path: '/mincetur/casino/sumarioDeJackpots',
            nome: '(3.7.4) Pago del Premio Mayor',
            permissao: 779
          },
          {
            path: '/mincetur/casino/apuestasDelJugadorCasino',
            nome: '(3.7.6) Juegos del Jugador',
            permissao: 778
          }
        ]
      }
    ]
  }
];

export default MENU_OPTIONS;

export const getMenuOptions = () => {
  return utils.getObjectRaw(MENU_OPTIONS);
};
